module.exports = __webpack_public_path__ + "static/img/login-samu-01.567f698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-samu-01.png
// module id = Nx7M
// module chunks = 4